module.exports = __webpack_public_path__ + "static/media/checklist.01097ea7.svg";